import { getCampaignArray } from "./get-campaign-array";
import { getCampaignMetaArray } from "./get-campaign-meta-array";
import { getUserRewardsInfo } from "./get-user-rewards-info";
import {
  createMerklCampaignMap,
  MerklCampaignMap,
  MerklCampaignMapService,
} from "./merkl-campaign-map";

export const MerklClient = {
  getCampaignMetaArray,
  getCampaignArray,
  getUserRewardsInfo,

  MerklCampaignMapService,
  MerklCampaignMap,
  createMerklCampaignMap,
};
